import React from 'react';
import { Link } from 'react-router-dom';

const hrefPatterns = {
    "user": "/admin/userSetup/{id}",
    "role": "/admin/roleSetup/{id}",
    "news": "/admin/newsSetup/{id}",
    "notification": "/admin/notificationSetup/{id}",
    "vob": "/admin/connectToVOB/{id}",
    "vobCertification": "/admin/certification/{parentId}/companyInfo",
    "vobOwner": "/admin/certification/{parentId}/veteranOwnerInfo",
    "sponsor": "/admin/sponsorSetup/{id}"
}

const types = {
    "user": "System User",
    "role": "Role",
    "news": "News",
    "notification": "Notification",
    "vob": "Company",
    "vobOwner": "Veteran Owners",
    "sponsor": "Corporate Member",
}

class AdminResult extends React.Component {

    render() {
        const r = this.props.result;

        try {
            var href = hrefPatterns[r.type].replace("{id}", r.id).replace("{parentId}", r.parentId);
            const type = types[r.type];

            if (r.type === "vob" && r.inactive === true)
                href = hrefPatterns["vobCertification"].replace("{id}", r.id).replace("{parentId}", r.parentId);

            return (
                <React.Fragment>
                    <div className="search-result">
                        <Link className="search-link" to={href}>{r.title}</Link><br />
                        <span className="search-type">{type}</span><br />
                        <span className="search-summary" dangerouslySetInnerHTML={{ __html: r.summary }} />
                    </div>
                </React.Fragment>
            )
        }
        catch (e) {
            return null;
        }
    }
}

export default AdminResult;



// WEBPACK FOOTER //
// ./src/areas/main/search/AdminResult.js